var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTasksSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4047 7.91664L2.23804 9.99997L10.2732 14.0176C10.3825 14.0722 10.4372 14.0996 10.4945 14.1103C10.5453 14.1198 10.5974 14.1198 10.6482 14.1103C10.7055 14.0996 10.7602 14.0722 10.8695 14.0176L18.9047 9.99997L14.738 7.91664M6.4047 12.0833L2.23804 14.1666L10.2732 18.1842C10.3825 18.2389 10.4372 18.2662 10.4945 18.277C10.5453 18.2865 10.5974 18.2865 10.6482 18.277C10.7055 18.2662 10.7602 18.2389 10.8695 18.1842L18.9047 14.1666L14.738 12.0833M2.23804 5.83331L10.2732 1.81571C10.3825 1.76105 10.4372 1.73372 10.4945 1.72297C10.5453 1.71344 10.5974 1.71344 10.6482 1.72297C10.7055 1.73372 10.7602 1.76105 10.8695 1.81571L18.9047 5.83331L10.8695 9.8509C10.7602 9.90556 10.7055 9.93289 10.6482 9.94365C10.5974 9.95317 10.5453 9.95317 10.4945 9.94365C10.4372 9.93289 10.3825 9.90556 10.2732 9.8509L2.23804 5.83331Z",
    stroke: "#0054B6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksSelected);
export default __webpack_public_path__ + "static/media/TasksSelected.c5fbdd4d3f2a19589cd1d5bae79bcaf2.svg";
export { ForwardRef as ReactComponent };